import { enableProdMode, importProvidersFrom, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { IonicStorageModule } from '@ionic/storage-angular';
import { StorageService } from '@services/storage.service';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { register } from 'swiper/element/bundle';
import { AuthInterceptor } from '@services/interceptor.service';
import { provideServiceWorker } from '@angular/service-worker';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LOCALE_ID } from '@angular/core';
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { IonicModule } from '@ionic/angular';
import { provideEnvironmentNgxCurrency, NgxCurrencyInputMode } from 'ngx-currency';

registerLocaleData(localePt);
register();

export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

if (environment.production) {
	enableProdMode();
}

bootstrapApplication(AppComponent, {
	providers: [
		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
		provideIonicAngular(),
		provideRouter(routes),
		importProvidersFrom(HttpClientModule),
		importProvidersFrom(IonicStorageModule.forRoot()),
		importProvidersFrom(IonicModule.forRoot({})),
		provideIonicAngular({
			rippleEffect: false,
			mode: 'md'
		}),
		StorageService,
		importProvidersFrom(AngularFireModule.initializeApp(environment.firebaseConfig)),
		importProvidersFrom(AngularFireMessagingModule),
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		provideServiceWorker('combined-sw.js', {
			enabled: !isDevMode(),
			registrationStrategy: 'registerWhenStable:30000'
		}),
		importProvidersFrom(
			TranslateModule.forRoot({
				defaultLanguage: 'pt',
				loader: {
					provide: TranslateLoader,
					useFactory: createTranslateLoader,
					deps: [HttpClient]
				}
			})
		),
		{ provide: LOCALE_ID, useValue: 'pt-PT' },
		provideEnvironmentNgxCurrency({
			align: 'left',
			allowNegative: true,
			allowZero: false,
			decimal: ',',
			precision: 2,
			prefix: '',
			suffix: ' €',
			thousands: '.',
			nullable: true,
			min: null,
			max: null,
			inputMode: NgxCurrencyInputMode.Financial
		})
	]
});
